import { isNonEmpty } from '@sgme/fp';
import { apiConnector } from 'apiConnector/secondary-market/legacyApiConnector';
import { ofType } from 'redux-observable';
import { of } from 'rxjs';
import { catchError, delay, filter, mergeMap, startWith, takeUntil } from 'rxjs/operators';
import {
  secondaryMarketQuoteCancelled,
  secondaryMarketQuoteFailed,
  secondaryMarketQuoteReceived,
} from 'state/secondaryMarket/realtimeQuote/quote';
import type { EpicWithThunk } from 'state/state.common';

export function quoteRequestEpic(): EpicWithThunk {
  return (action$, _state$, { httpClient, getNow }) => {
    const { astroQuote: legacyQuote } = apiConnector(httpClient);
    return action$.pipe(
      ofType('SECONDARY_MARKET_QUOTE_REQUESTED'),
      mergeMap(({ request, tabId }) => {
        return legacyQuote(request).pipe(
          mergeMap(({ data, errors }) => {
            if (isNonEmpty(errors)) {
              return of(secondaryMarketQuoteFailed(tabId, data.quoteId, ...errors.map(e => e.message)));
            }
            const { quoteId, ...quote } = data;
            const tradeAuthorizationStart = getNow();

            const tradeAuthorizationEnded$ = action$.pipe(
              ofType('SECONDARY_MARKET_QUOTE_CANCELLED', 'SECONDARY_MARKET_TRADE_REQUESTED'),
              filter(q => q.quoteId === quoteId),
            );

            return of(secondaryMarketQuoteCancelled(tabId, quoteId)).pipe(
              delay(quote.timeToTradeInSeconds * 1000),
              takeUntil(tradeAuthorizationEnded$),
              startWith(secondaryMarketQuoteReceived(tabId, quoteId, { ...quote, tradeAuthorizationStart })),
            );
          }),
          catchError(error =>
            of(
              secondaryMarketQuoteFailed(
                tabId,
                null,
                error.payload ? `${error.message}: ${error.payload}` : error.message,
              ),
            ),
          ),
        );
      }),
    );
  };
}
